// @flow
import React from 'react'
import { connect } from 'react-redux'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import Card from 'components/Card/Card'
import { httpUrl } from 'lib/http'
import styles from './SubaccountReport.css'
import queryString from 'query-string'
import streamSaver from 'streamsaver'
import { setLoad, setUnload } from 'lib/notification/actions'

type Props = {
  dispatch: Function,
}

type State = {
  dateEnd: string,
}

class SubaccountReport extends React.Component<Props, State> {
  props: Props

  constructor(props) {
    super(props)
    this.state = { dateEnd: '' }
  }

  onChange = (event) => {
    const { name, value } = event.currentTarget
    this.setState({ [name]: value })
  }

  render() {
    const { dateEnd } = this.state

    return (
      <div className={styles.subaccountReport}>
        <Breadcrumbs crumbs={['Subaccount Reports']} />
        <div className={styles.body}>
          <Card>
            <div className={styles.form}>
              <div className={styles.formItemMono}>
                <label className={styles.label} htmlFor="dateEnd">
                  Period End Date (optional)
                </label>
                <input
                  className={styles.input}
                  type="date"
                  name="dateEnd"
                  value={dateEnd}
                  onChange={this.onChange}
                />
              </div>
              <div className={styles.reports}>
                <button onClick={() => this.exportReport('home')}>
                  Home Land and Mortgage Report
                </button>
                <button onClick={() => this.exportReport('msa')}>
                  MSA Report
                </button>
                <button onClick={() => this.exportReport('investment')}>
                  Investments Report
                </button>
                <button onClick={() => this.exportReport('vehicle')}>
                  Vehicles Report
                </button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    )
  }

  exportReport = (reportType) => {
    const sid = localStorage.getItem('sid')
    const base_url = httpUrl('/admin/reporting/subaccount-report')
    const query = {
      report_type: reportType,
      ...(this.state.dateEnd && { date_end: this.state.dateEnd }),
    }

    const qs = queryString.stringify(query, { arrayFormat: 'bracket' })
    const url = `${base_url}?${qs}`

    const { dispatch } = this.props
    dispatch(setLoad())

    fetch(url, {
      headers: {
        Authorization: `Bearer ${sid}`,
      },
    }).then((response) => {
      dispatch(setUnload())
      const fileStream = streamSaver.createWriteStream(
        `subaccount-${reportType}-report.csv`,
      )
      response.body.pipeTo(fileStream)
    })
  }
}

export default connect()(SubaccountReport)
